import axios from "axios";
import {
  GET_OTHER_FAILD,
  GET_OTHER_LOAD,
  GET_OTHER_SUCCESS,
} from "../constants/other";

export const getallOther = () => async (dispatch) => {
  const config = {
    headers: {
      authorization: localStorage.getItem("token"),
    },
  };
  dispatch({ type: GET_OTHER_LOAD });

  try {
    let results = await axios.get("/api/other/others", config);
    // if i send an http request result bech tekho objet { status , headers ,data li jet mel api }
    dispatch({
      type: GET_OTHER_SUCCESS,
      payload: results.data, // (hedhy tji feha un objet fih msg w EVENT)
    });
  } catch (error) {
    dispatch({ type: GET_OTHER_FAILD });
    console.log(error);
  }
};
export const addOther = (other, history) => async (dispatch) => {
  const config = {
    headers: {
      authorization: localStorage.getItem("token"),
    },
  };
  dispatch({ type: GET_OTHER_LOAD });
  try {
    await axios.post("/api/other", other, config);
    // dispatch({ type: SUCCESS });
    dispatch(getallOther());

    history.push("/others");
  } catch (error) {
    dispatch({ type: GET_OTHER_FAILD });
    console.log(error);
  }
};

export const deleteOther = (id) => async (dispatch) => {
  dispatch({ type: GET_OTHER_LOAD });
  try {
    await axios.delete(`/api/other/${id}`);
    dispatch(getallOther());
  } catch (error) {
    dispatch({ type: GET_OTHER_FAILD });
    console.log(error);
  }
};
